module.exports = __webpack_public_path__ + "img/r.6a6bbf76.jpg";